import { createSlice } from '@reduxjs/toolkit';
import { removeStudyMarking } from '../../../rtk-apis/reports/removeStudyMarkingApi';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const removeStudyMarkingSlice = createSlice({
  name: 'removeStudyMarkingSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(removeStudyMarking.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(removeStudyMarking.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg;
      })
      .addCase(removeStudyMarking.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = '';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default removeStudyMarkingSlice.reducer;
export const { clearState } = removeStudyMarkingSlice.actions;
